<div class="header-slider">
  <div class="carousel slide carousel-fade">
    @for (src of this.sliderImgsSrc; track src; let i = $index) {
      <div class="carousel-item" [class.active]="i === activeIndex">
        <div class="view w-100 position-relative">
          <img class="d-block w-100" [src]="src" height="800px" alt="First slide">
          <div class="mask rgba-black-light waves-light"></div>
        </div>
        <div class="carousel-caption">
          <h2 class="h3-responsive">{{this.sliderHeaderList[i]}}</h2>
          <p>{{this.sliderTextList[i]}}</p>
        </div>
      </div>
    }
  </div>
</div>

